import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, retry } from 'rxjs/operators';

import { environment } from '../../../environments/environment';
import { User } from '../../variables/user';

import { Router } from '@angular/router';

// https://jasonwatmore.com/post/2020/07/06/angular-10-communicating-between-components-with-observable-subject

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  private currentUserSubject: BehaviorSubject<User>;
  public currentUser: Observable<User>;

  constructor(private http: HttpClient, private router: Router) {
    this.currentUserSubject = new BehaviorSubject<User>(
      JSON.parse(localStorage.getItem('currentUser'))
    );
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): User {
    return this.currentUserSubject.value;
  }

  login(client_pin: string) {
    return this.http
      .post<any>(`${environment.apiUrl}/login/login.php`, {
        client_pin,
      })
      .pipe(
        map((user) => {
          // store user details and jwt token in local storage to keep user logged in between page refreshes

          //alert(user.error)

          //alert(JSON.stringify(user));
          // var start_json_array=[];

          //start_json_array[mass_start_id]=[unix_time, localStorage.getItem('global_user_name')];
          //start_json_array[0]=[0, ''];
          // localStorage.setItem('global_start_json', JSON.stringify(start_json_array))
          this.currentUserSubject.next(user);
          return user;
        }),
        retry(3)
      );
  }

  logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('currentUser');
    localStorage.removeItem('global_menu_json');
    localStorage.removeItem('global_client_id');
    localStorage.removeItem('global_device_id');
    localStorage.removeItem('global_user_name');
    localStorage.removeItem('global_client_pin');

    localStorage.removeItem('global_logged_in')
    localStorage.removeItem('global_current_route')

    localStorage.removeItem('global_stage_type')
    localStorage.removeItem('current_mass_start_id')
    localStorage.removeItem('current_mass_start_name')	

    /*
    global_input_method	
    global_stage_type
    current_mass_start_id
    global_current_camera
    global_start_json
    current_mass_start_name	
    currentUser
    global_menu_json
    global_client_id
    global_device_id
    global_user_name
    global_client_pin
    */

    this.currentUserSubject.next(null);
  }

  check_logged_in() {
    var is_logged_in = localStorage.getItem('global_logged_in');
    if (is_logged_in != 'Yes') {
      this.logout();
      this.router.navigate(['/login']);
    }
  }

  save_current_route(){
    //console.log('!!!!!!!!!!!!!!!!');
    //console.log(this.router.url);

    localStorage.setItem('global_current_route', this.router.url);

    // Save when last the app was used
    var time_now=Math.floor(Date.now() / 1000);
    var time_now_string = time_now.toString();
    localStorage.setItem('global_time_now', time_now_string);
  }
}
